import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {ConfigTable as _ConfigTable} from 'app-ui-componentlibrary/dist/componentLibrary/layout/ConfigTable';
import contentMap from 'componentLibrary';

export const ConfigTable = (props) => <_ConfigTable {...props} {...{contentMap}} />;
export const DynamicTable = connectWithCore(ConfigTable);
export default DynamicTable;
